import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { PublicSellerAuthLoginResponse } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";

type SellerLoginInput = {
  phone: string;
  password: string;
};

export function useLoginMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    meta: { skipGlobalErrorToast: true },
    mutationFn: (input: SellerLoginInput) =>
      apiJsonClient<PublicSellerAuthLoginResponse>(endpoints.public.sellerAuth.login, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(input),
      }),
    onSuccess: () => {
      // Remove all cached seller queries so ProtectedLayout mounts with a
      // clean slate. If we only invalidate (mark stale), ProtectedLayout's
      // first synchronous render can still see the cached 401 error from the
      // previous (expired) session before the background refetch starts,
      // causing an immediate redirect back to /login and a redirect loop.
      queryClient.removeQueries({ queryKey: ["seller"] });
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
